export enum Permissions {
  WGDashboardAccess = 'wg_dashboard:access',
  PDDashboardAccess = 'pd_dashboard:access',
  FundraiserWrite = 'fundraiser:write',
  FundraiserMakePublic = 'fundraiser:make_public',
  FundraisersManage = 'partner_fundraiser:write',
  CampaignsWrite = 'giving_campaigns:write',
  OpportunitiesManage = 'opportunities:write',
  OpportunityWrite = 'opportunities:create',
  OpportunitiesPreEventSurveysWrite = 'opportunities_pre_event_surveys:write',
  OpportunitiesPostEventSurveysWrite = 'opportunities_post_event_surveys:write',
  OpportunitiesWaiversWrite = 'opportunities_waivers:write',
  ContentTagsWrite = 'content_tags:write',
  FundraiserSetMatchingRate = 'fundraiser:set_matching_rate'
}
